export const getExtension = filename => {
  return filename
    .split('.')
    .pop()
    .toLowerCase();
};

export const validateFileExtension = (
  filename,
  validFileTypes = ['png', 'jpg', 'jpeg', 'pdf'],
) => {
  if (!filename) {
    return false;
  } else {
    const extension = getExtension(filename);

    if (validFileTypes.indexOf(extension) === -1) {
      return false;
    } else {
      return true;
    }
  }
};
